<template>
    <div>
      <page-error-iquote-not-available v-if="!loadingError && !isAvailable"></page-error-iquote-not-available>
      <div v-else>
        <div class="container container-full-width-small px-0">
          <router-view></router-view>
        </div>
      </div>
    </div>

</template>

<script>
import PageErrorIquoteNotAvailable from '@/components/main/error/PageErrorIquoteNotAvailable.vue'
import { mapGetters} from 'vuex'

export default {
  name: 'B2bOfferProposal',
  components: {
    PageErrorIquoteNotAvailable,
  },
  computed: {
    ...mapGetters(['loadingError', 'isAvailable']),
  },

  mounted() {
    const { iquoteId } = this.$route.params
  
    if (iquoteId) {
      this.$store.commit('SET_IQUOTE_ID', iquoteId)

      this.$store.dispatch('getIquote', 'b2b').then(iquote => {
        if (iquote.chosenQuoteId) {
          this.$router.push({
            name: 'B2bConfirmation'
          })
        }
      })
    }
  }
}
</script>


